export function convertMinutes(minutes) {
	if (!minutes && minutes !== 0) return '';
	const hours = Math.floor(minutes / 60);
	const remainingMinutes = minutes % 60;
	return `${hours}hr ${remainingMinutes}min`;
}

/**
 * Converts a date string from MM/DD/YYYY HH:MM:SS format to Indian Standard Time (IST)
 *
 * @param {string} dateString - Date string in format "MM/DD/YYYY HH:MM:SS"
 * @returns {string} Date string converted to IST in format "DD/MM/YYYY HH:MM:SS"
 *                   Returns empty string if input is invalid or parsing fails
 *
 * @example
 * // Returns "26/05/2023 14:30:00"
 * convertToIST("05/26/2023 09:00:00")
 */
export const convertToIST = (dateString) => {
	if (!dateString) return '';

	try {
		const [datePart, timePart] = dateString.split(' ');
		const [month, day, year] = datePart.split('/');

		const date = new Date(`${year}-${month}-${day}T${timePart}Z`);

		date.setTime(date.getTime() + (5 * 60 + 30) * 60 * 1000);

		const formattedDay = date.getUTCDate().toString().padStart(2, '0');
		const formattedMonth = (date.getUTCMonth() + 1).toString().padStart(2, '0');
		const formattedYear = date.getUTCFullYear();
		const formattedHours = date.getUTCHours().toString().padStart(2, '0');
		const formattedMinutes = date.getUTCMinutes().toString().padStart(2, '0');
		const formattedSeconds = date.getUTCSeconds().toString().padStart(2, '0');

		return `${formattedDay}/${formattedMonth}/${formattedYear} ${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
	} catch (error) {
		console.error('Error formatting date:', error);
		return '-';
	}
};

/**
 * Converts a date string from ISO format to MM/DD/YYYY HH:MM:SS format
 *
 * @param {string} dateString - Date string in format "YYYY-MM-DDTHH:MM:SS.SSSSSS"
 * @returns {string} Date string converted to format "MM/DD/YYYY HH:MM:SS"
 *                   Returns empty string if input is invalid or parsing fails
 */
export const convertToIST_NEW = (dateString) => {
	if (!dateString) return '';

	try {
		const date = new Date(dateString);

		// Check if the date is valid (not NaN)
		if (Number.isNaN(date.getTime())) {
			return '-';
		}

		const month = (date.getMonth() + 1).toString().padStart(2, '0');
		const day = date.getDate().toString().padStart(2, '0');
		const year = date.getFullYear();
		const hours = date.getHours().toString().padStart(2, '0');
		const minutes = date.getMinutes().toString().padStart(2, '0');
		const seconds = date.getSeconds().toString().padStart(2, '0');

		return `${month}/${day}/${year} ${hours}:${minutes}:${seconds}`;
	} catch (error) {
		console.error('Error formatting date:', error);
		return '-';
	}
};
